import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ChatActions from 'src/store/modules/chat/actions';

function TagSelector({
  selectedTag,
  onTagSelect,
  placeholder = 'Selecione uma etiqueta',
  disabled = false,
  allTags = [],
  getTags,
  isDarkMode = false,
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Busca tags quando o componente é montado
  useEffect(() => {
    if (getTags) {
      getTags();
    }
  }, [getTags]);

  // Função para alternar o dropdown
  const toggleDropdown = () => {
    if (!disabled) {
      setDropdownOpen(!dropdownOpen);
    }
  };

  // Função para selecionar uma tag
  const handleTagSelect = (tag) => {
    onTagSelect(tag);
    setDropdownOpen(false);
  };

  // Função para fechar o dropdown ao clicar fora
  const handleClickOutside = (e) => {
    if (!e.target.closest('.tag-selector-container')) {
      setDropdownOpen(false);
    }
  };

  // Adiciona listener para cliques fora do dropdown
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div
      className="tag-selector-container"
      style={{ position: 'relative', width: '100%' }}
    >
      {/* Campo de seleção principal */}
      <div
        onClick={toggleDropdown}
        style={{
          padding: '8px 12px',
          border: isDarkMode
            ? '1px solid var(--border-color)'
            : '1px solid #ced4da',
          borderRadius: '4px',
          backgroundColor: disabled
            ? isDarkMode
              ? 'var(--secondary-background-color)'
              : '#f8f9fa'
            : isDarkMode
            ? 'var(--secondary-background-color)'
            : '#fff',
          cursor: disabled ? 'not-allowed' : 'pointer',
          fontSize: '14px',
          minHeight: '38px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <span
          style={{
            color: selectedTag?.value
              ? isDarkMode
                ? 'var(--primary-font-color)'
                : '#333'
              : isDarkMode
              ? 'var(--tertiary-font-color)'
              : '#6c757d',
          }}
        >
          {selectedTag?.name || placeholder}
        </span>
        <div
          style={{
            width: '0',
            height: '0',
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            borderTop: '6px solid #6c757d',
            marginLeft: '8px',
            flexShrink: 0,
            transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
          }}
        />
      </div>

      {/* Dropdown de opções */}
      {dropdownOpen && !disabled && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: isDarkMode
              ? 'var(--primary-background-color)'
              : '#fff',
            border: isDarkMode
              ? '1px solid var(--border-color)'
              : '1px solid #ced4da',
            borderRadius: '4px',
            boxShadow: isDarkMode
              ? '0 4px 6px rgba(255, 255, 255, 0.1)'
              : '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
            maxHeight: '200px',
            overflowY: 'auto',
          }}
        >
          {allTags && allTags.length > 0 ? (
            allTags.map((tag) => (
              <div
                key={tag.id}
                onClick={() => handleTagSelect(tag)}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  borderBottom: isDarkMode
                    ? '1px solid var(--border-color)'
                    : '1px solid #f0f0f0',
                  fontSize: '12px',
                  backgroundColor:
                    selectedTag?.value === tag.value
                      ? isDarkMode
                        ? 'var(--secondary-background-color)'
                        : '#f8f9fa'
                      : isDarkMode
                      ? 'var(--primary-background-color)'
                      : '#fff',
                  color: isDarkMode ? 'var(--primary-font-color)' : '#333',
                }}
                onMouseEnter={(e) => {
                  if (selectedTag?.value !== tag.value) {
                    e.target.style.backgroundColor = isDarkMode
                      ? 'var(--secondary-background-color)'
                      : '#f8f9fa';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedTag?.value !== tag.value) {
                    e.target.style.backgroundColor = isDarkMode
                      ? 'var(--primary-background-color)'
                      : '#fff';
                  }
                }}
              >
                {tag.name}
              </div>
            ))
          ) : (
            <div
              style={{
                padding: '12px',
                textAlign: 'center',
                color: isDarkMode ? 'var(--tertiary-font-color)' : '#6c757d',
                fontSize: '12px',
                fontStyle: 'italic',
              }}
            >
              Nenhuma etiqueta disponível
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  allTags: state.chat?.config?.general?.tags || [],
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ChatActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TagSelector);
